import React, { useState } from 'react';

export const MiddleAlert = ({ icon = null, type = 'info', title, message, footer = null }) => {
  const [visible, setVisible] = useState(true);

  const styles = {
    warning: {
      bg: 'bg-warning-100',
      border: 'border-yellow-500',
      titleColor: 'text-neutral-900',
      messageColor: 'text-neutral-800',
      button: 'text-yellow-600 hover:text-yellow-800'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      titleColor: 'text-neutral-900',
      messageColor: 'text-neutral-800',
      button: 'text-blue-600 hover:text-blue-800'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      titleColor: 'text-neutral-900',
      messageColor: 'text-neutral-800',
      button: 'text-red-600 hover:text-red-800'
    }
  };

  const handleIgnore = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  const currentStyle = styles[type] || styles.info;
  return (
    <div
      className={`z-50 flex items-start rounded-lg border-l-4 p-4 ${currentStyle.bg} ${currentStyle.border}`}>
      <div className="mr-3 flex-shrink-0">{icon}</div>
      <div className="flex flex-col gap-2">
        <strong className={`font-500 ${currentStyle.titleColor}`}>{title}</strong>
        <p className={`text-sm ${currentStyle.messageColor}`}>{message}</p>
        {footer}
      </div>
      <button
        onClick={handleIgnore}
        className={`ml-3 ${currentStyle.button} hover:${currentStyle.button}`}>
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};
